<template>
  <div id="departments">
    <div>
      <!-- 表格区域 -->
      <vxe-grid
        ref="xGrid"
        v-bind="gridOptions"
        @edit-actived="editActivedEvent"
        @cell-dblclick="noEdit"
        @checkbox-change="checkboxChangeEvent"
        @checkbox-all="checkboxChangeEvent"
        class="affect-item"
        :header-cell-class-name="headerCellClassName"
        :cell-class-name="xxcellClassName"
      >
        <template #AI_toolbar_buttons>
          <div style="display: flex">
            <el-button
              class="btn btn1"
              icon="el-icon-circle-plus-outline"
              @click="searchAddRel = true"
              :disabled="!addTableListPriv || !workFlowStatus"
              >{{ $t('message.button.add') }}
            </el-button>
            <el-button
              class="btn btn2"
              icon="el-icon-delete"
              @click="removeCheckbox"
              :disabled="!removeTableListPriv || !workFlowStatus"
              >{{ $t('message.button.delete') }}
            </el-button>
            <el-button
              class="btn btn3"
              icon="el-icon-document-checked"
              @click="getUpdateEvent"
              v-if="!editShow"
              :disabled="!pageChanged || !workFlowStatus"
              >{{ $t('message.button.save') }}
            </el-button>
            <el-button
              class="btn btn4"
              icon="el-icon-circle-close"
              @click="closeSave"
              v-if="!editShow"
              :disabled="!workFlowStatus"
              >{{ $t('message.button.cancel') }}
            </el-button>
          </div>
        </template>
        <template #bottom>
          <Bottom-Tips
            :data="{ selectRecords: selectRecords.length, totalRecords }"
          />
        </template>
      </vxe-grid>
    </div>

    <el-dialog
      class="searchAddBomList"
      v-if="searchAddRel"
      :title="$t('message.title.add')"
      :visible.sync="searchAddRel"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <SearchQualityItem @listDbClick="addList"></SearchQualityItem>
    </el-dialog>
  </div>
</template>
<script>
import SearchQualityItem from '@/components/searchQualityItem.vue' //引进菜单模板
import { mapState, mapMutations } from 'vuex'
import axios from 'axios'
export default {
  data() {
    return {
      componentname: this.$route.matched[1].path.slice(1),
      redLine: true,
      searchAddRel: false, //添加窗口开关
      version: '',
      selectRecords: [],
      totalRecords: '',
      gridOptions: {
        toolbarConfig: {
          // zoom: true,
          // custom: true,
          // print: true,
          slots: {
            buttons: 'AI_toolbar_buttons',
          },
        },
        keepSource: true,
        resizable: true,
        border: true,
        stripe: true,
        highlightHoverRow: true,
        highlightCurrentRow: true,
        showHeaderOverflow: true,
        showOverflow: true,
        autoResize: true,
        rowId: 'id',
        height: '520',
        size: 'small',
        columns: [],
        data: [],
        treeConfig: {
          lazy: true,
          children: 'children',
          hasChild: 'hasChildren',
          loadMethod: this.loadChildrenMethod,
        },
        editConfig: {
          trigger: 'dblclick',
          mode: 'cell',
          showIcon: false,
          activeMethod: this.activeRowMethod,
          showStatus: true,
        },
        sortConfig: {
          trigger: 'cell',
        },
      },
      editShow: false,
      workFlowStatus: true, //变更工作流状态
      loading: true,
      cols: [], //表头
      rols_text: [], //表体显示内容
      get_change_info: '', //父组件传来的值
      //权限
      addTableListPriv: false,
      removeTableListPriv: false,
      cascaderShow: false,
      cascaderValue: [],
      cascaderList: [],
      cascaderProps: {},
      cachePnameList: [],
    }
  },
  mounted() {},
  components: {
    SearchQualityItem,
  },
  methods: {
    ...mapMutations([
      'setPageChanged',
      'setPageRefresh',
      'replaceShowingTabsInHome',
      'setActivedTabInHome',
    ]),
    headerCellClassName({ column }) {
      if (column.editRender && column.editRender?.enabled) {
        return 'col-blue'
      }
      return null
    },

    xxcellClassName({ row, column }) {
      console.log(column)

      if (column.editRender && column.editRender?.enabled) {
        return 'col-custom-edit'
      }
      return null
    },

    editActivedEvent() {
      this.$store.commit('setPageChanged', {
        name: this.componentname,
        isChanged: true,
      })
    },
    checkboxChangeEvent({ records }) {
      const $grid = this.$refs.xGrid
      this.selectRecords = records
    },

    removeCheckbox() {
      //删除
      var removeRow = this.$refs.xGrid.getCheckboxRecords()
      var vm = this
      if (removeRow.length == 0) {
        return false
      } else {
        let deletedQualityItems = {
          qualityObjId: {
            ...this.$store.state.objectId,
            version: 0,
          },
          deleteQualityItems: [],
          tableId: 41,
        }
        var del_table = []
        for (var i = 0; i < removeRow.length; i++) {
          del_table.push(removeRow[i].rowId)
        }
        deletedQualityItems.deleteQualityItems = del_table
        axios
          .post('/pqm/quality/deleteTable', deletedQualityItems)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: 'success',
              })
              this.getRelInfo()
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },

    addList(row) {
      //添加
      let insertQualityItems = row.map((i) => {
        return {
          itemId: i.itemId,
          itemSubclassId: i.itemSubClass || i.itemSubClassId,
          qualityId: this.$store.state.objectId.id,
        }
      })
      var insertQuality = {
        //post更改的值
        tableId: 41,
        qualityObjId: {
          ...this.$store.state.objectId,
          version: 0,
        },
        insertQualityItems: insertQualityItems,
      }
      axios
        .post('/pqm/quality/saveTable', insertQuality)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: 'success',
            })
          }
          this.getRelInfo()
        })
        .catch()
    },

    closeSave() {
      this.$store.commit('setPageChanged', {
        name: this.componentname,
        isChanged: false,
      })
      this.$refs.xGrid.revertData() //清除所有保存，删除，添加记录
    },

    async noEdit({ row, column, columnIndex }) {
      var getIRL = {
        id: row.itemId,
        subClassId: row.itemSubClassId,
      }
      let subClsIdListId = this.gridOptions.columns[columnIndex]
      if (
        subClsIdListId.attid == '4011006' ||
        subClsIdListId.attid == '4011007'
      ) {
        const getItemRevListBySubclassUrl = `/pmdm/technology/getRevList${this.params(
          getIRL
        )}`
        const { data: res } = await this.$http.get(getItemRevListBySubclassUrl)
        if (res.code == 200) {
          var select_val = []
          var val = res.object.revList
          for (var key in val) {
            if (!val[key].editable) continue
            var select_obj = {}
            select_obj.label = val[key].val
            select_obj.value = val[key].id
            select_val.push(select_obj)
          }
          this.cachePnameList = this.cachePnameList.concat(select_val)
          this.gridOptions.columns[columnIndex].editRender.options = select_val
        }
      }
      if (column.editRender.cascaderType && this.editTable) {
        this.cascaderList = column.editRender.cascadeOptions
        let m = row[[column.property]]
        if (column.editRender.props.multiple) {
          this.cascaderValue = m
            ? m.map((i) => {
                return this.getParentIdList(this.cascaderList, i)
              })
            : ''
          this.cascaderProps.multiple = true
        } else {
          this.cascaderProps.multiple = false
          this.cascaderValue = m
        }
        this.cascaderProps.checkStrictly = true
        this.tempData = { row, column }
        this.cascaderShow = true
      }
    },

    getUpdateEvent() {
      var xGrid_ = this.$refs.xGrid
      var columns = this.gridOptions.columns
      var cols_ = this.cols
      let updateRecords = xGrid_.getUpdateRecords() //获取修改的行
      var cols_length = cols_
      var updateRel = []
      if (updateRecords.length !== 0) {
        //判断行内那些值有改动
        for (let i = 0; i < updateRecords.length; i++) {
          var num = xGrid_.getRowIndex(updateRecords[i])
          for (let j = 0; j < cols_length.length; j++) {
            var updateNewData = xGrid_.isUpdateByRow(updateRecords[i], '' + j)
            if (updateNewData) {
              for (let k = 0; k < columns.length; k++) {
                var obj = {}
                if (cols_length[j] == columns[k].attid) {
                  var quantity = cols_length[j]
                  obj.id = updateRecords[i].rowId
                  if (columns[k].editRender.props) {
                    //处理多选和单选
                    if (columns[k].editRender.props.multiple) {
                      obj[quantity] = updateRecords[i][j].join(';')
                    } else if (columns[k].editRender.props.type == 'datetime') {
                      obj[quantity] = this.format(
                        updateRecords[i][j],
                        'yyyy-MM-ddThh:mm:ss'
                      )
                    } else {
                      if (updateRecords[i][j] == null) {
                        obj[quantity] = ''
                      } else {
                        obj[quantity] = updateRecords[i][j]
                      }
                    }
                  } else {
                    if (updateRecords[i][j] == null) {
                      obj[quantity] = ''
                    } else {
                      obj[quantity] = updateRecords[i][j]
                    }
                  }
                  updateRel.push(obj)
                }
              }
            }
          }
        }
        var updateRelData = {
          //post更改的值
          qualityObjId: {
            ...this.$store.state.objectId,
            version: 0,
          },
          tableId: 41,
          updateQualityItems: this.ArrayFilter(updateRel),
        }
        axios
          .post('/pqm/quality/updateTable', updateRelData)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message({
                message: res.data.message,
                type: 'success',
              })
              this.getRelInfo()
              this.$store.commit('setPageChanged', {
                name: this.componentname,
                isChanged: false,
              })
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    },

    ArrayFilter(l) {
      let arr = l
      let list = arr.reduce((pre, cur) => {
        let target = pre.find((ee) => ee.id == cur.id)
        if (target) {
          Object.assign(target, cur)
        } else {
          pre.push(cur)
        }
        return pre
      }, [])
      return list
    },

    activeRowMethod({ row }) {
      return !row.disable
    },

    getRelInfo() {
      this.$emit('refreshTab')
      var change_info = this.$store.state.change_info
      if (this.get_change_info == '') {
        change_info = this.$store.state.change_info
      } else {
        change_info = this.get_change_info
      }
      var obj_get = {
        //获取change
        ...this.$store.state.objectId,
        ...change_info,
        tableId: 41,
      }
      var loadTableUrl = `/pqm/quality/loadTable${this.params(obj_get)}`
      axios.get(loadTableUrl).then((res) => {
        this.gridOptions.columns = this.getNewTableTitleData(res.data)
        this.cols = res.data.object.table.columnInfo.ids
        this.rols_text = this.getNewTableContentData(res.data)
        this.$refs.xGrid.loadData(this.rols_text)
        this.totalRecords = res.data.object.table.totalRecords
        this.version = res.data.object.table.version
        this.selectRecords = []
      })
    },

    loadUserPriv() {
      var priv_ = this.getUserContextPriv()
      let subClass_Id = this.$store.state.objectId.subClassId
      for (let i = 0; i < priv_.length; i++) {
        if (priv_[i].classId == subClass_Id) {
          if (priv_[i].type == 3) {
            this.addTableListPriv = true
          }
          if (priv_[i].type == 4) {
            this.removeTableListPriv = true
          }
        }
      }
      let isSupAdmin = this.$store.state.isSuperAdmin
      if (isSupAdmin) {
        this.addTableListPriv = true
        this.removeTableListPriv = true
      }
    },
  },

  created() {
    this.loadUserPriv()
    this.getRelInfo()
    setTimeout(() => {
      this.loading = false
    }, 500)
  },
  computed: {
    loadWorkFlowStatus() {
      return this.$store.state.changeWorkflowStatus
    },
    ...mapState({
      pageChanged: (state) => state.pageChanged,
    }),
  },
  props: ['changeValue', 'relUrl', 'type'],
  watch: {
    changeValue: function (value) {
      this.get_change_info = value
      //console.log(value);
      this.getRelInfo()
    },
    loadWorkFlowStatus: {
      handler(val) {
        const baseId = this.$store.state.objectId.classId
          .toString()
          .substr(0, 3)
        if (baseId == 401) {
          this.workFlowStatus = ![3, 4].includes(val)
        } else {
          this.workFlowStatus = true
        }
        console.log({ baseId, val, w: this.workFlowStatus })
      },
      deep: true,
      immediate: true,
    },
  },
  beforeRouteLeave(to, from, next) {
    const tabs = [...this.$store.state.showingTabsInHome]
    const activeName = this.$store.state.activedTabInHome
    if (!this.$store.state.pageChanged) {
      this.$store.commit('setNavigationTriggered', false)
      return next()
    }
    const navigationTriggered = this.$store.state.navigationTriggered

    if (navigationTriggered) {
      to = this.$store.state.routerTo
      from = this.$store.state.routerFrom
      return next(false)
    } else {
      this.$store.commit('setRouterTo', to)
      this.$store.commit('setRouterFrom', from)
    }

    this.$store.commit('setNavigationTriggered', true)

    this.$confirm('当前页面有未保存信息，确定离开么', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.setPageChanged({ name: this.componentname, isChanged: false })
        this.$store.commit('setNavigationTriggered', false)
        next(to)
        if (to.path == from.matched[1].path) {
          this.setPageRefresh()
        }
      })
      .catch(() => {
        this.replaceShowingTabsInHome(tabs)
        this.setActivedTabInHome(activeName)
        this.$store.commit('setNavigationTriggered', false)
        next(false)
      })
  },
}
</script>
<style>
.RelSearchAddBomList .el-dialog__body {
  padding: 0 20px 20px 20px !important;
}

.el-table th.gutter {
  display: table-cell !important;
}

.link_ {
  color: #4b92ff;
  cursor: pointer;
}

.link_:hover {
  color: #4b92ff;
  cursor: pointer;
  border-bottom: 1px solid #4b92ff;
}

.mytable-style .vxe-body--column.col-red {
  text-decoration: line-through;
  color: red;
}

.mytable-style .vxe-body--column.col-red span {
  color: #000;
}

.mytable-style .vxe-body--column.col-red-text {
  color: red;
}

.mytable-style .vxe-body--column.col-red-text span {
  color: red;
}
</style>

<style scoped>
.line-1 {
  height: 6px;
  background: #ebebeb;
}

.content-title {
  padding: 0;
  margin: 0;
  overflow: hidden;
  background-size: 100% 100%;
  height: 40px;
  margin-left: 20px;
}

.content-title li {
  float: left;
  padding: 8px 8px 8px 8px;
  font-size: 14px;
  cursor: pointer;
  margin-right: 18px;
}

.content-title li:hover {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}

.content-title .active {
  border-bottom: 3px solid #4b92ff;
  color: #4b92ff;
}
</style>
